// extracted by mini-css-extract-plugin
module.exports = {"elements":"pager-view_elements__MTowl","element":"pager-view_element__2KeDa","icon":"pager-view_icon__1rOQY"};